import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader } from 'reactstrap';

import QaReportFormContainer from './QaReportFormContainer';

const propTypes = {
  title: PropTypes.string.isRequired,
  testType: PropTypes.string.isRequired,
};

class QaReportModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false
    };
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const { title, testType } = this.props;

    return (
      <div>
        {this.props.children}
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
          <QaReportFormContainer
            onCancel={this.toggle}
            testType={testType}
          />
        </Modal>
      </div>
    );
  }
}

QaReportModal.propTypes = propTypes;

export default QaReportModal;



// WEBPACK FOOTER //
// ./src/features/qa/QaReportModal/index.js